import React from 'react';
import './Logo.css';

function Logo() {
  return (
    <div className="logo">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="logoGradient" x1="0%" y1="0%" x2="100%" y2="100%">
            <stop offset="0%" stopColor="#667eea" />
            <stop offset="100%" stopColor="#764ba2" />
          </linearGradient>
        </defs>
        
        {/* Stylized M shape with tech feel */}
        <path 
          d="M5 30 L5 10 L12 20 L20 10 L28 20 L35 10 L35 30 L30 30 L30 18 L20 28 L10 18 L10 30 Z" 
          fill="url(#logoGradient)"
        />
        
        {/* Small tech dots/nodes */}
        <circle cx="12" cy="20" r="2" fill="#3b82f6" />
        <circle cx="28" cy="20" r="2" fill="#3b82f6" />
        <circle cx="20" cy="10" r="2" fill="#764ba2" />
      </svg>
      
      <div className="logo-text">
        <span className="logo-name">Mndini</span>
        <span className="logo-tagline">Technologies</span>
      </div>
    </div>
  );
}

export default Logo;
